import React, {useState} from "react"
import {AsyncResultModal} from "../AsyncResultModal/AsyncResultModal"
import useAsyncResultIdle from "../../hooks/useAsyncResultIdle"
import {useAccessToken} from "../../services/auth"
import Admonition from "../../components/Admonitions/Admonition"
import {rejectCheckDeposit} from "../../resources/checkDeposits"

interface RejectCheckModalProps {
	id: string
	closeModal: () => void
	onSuccess: () => void
	isVeryfi: boolean
}

const presetReasonsSmartpay = [
	"Blank Check",
	"Duplicate Check",
	"Incomplete Check",
	"Date Issue",
	"Missing Signature",
	"Missing Endorsement",
	"Beneficiary Name Mismatch",
	"Amount Mismatch",
	"Altered / Fictitious",
	"Suspected Counterfeit",
	"Partial Endorsement",
	"Ineligible Item",
	"Non-Compliant Image",
	"Other",
]

const presetReasonsVeryfi = [
	"Blank check",
	"Missing date",
	"Post dated",
	"Stale dated",
	"Missing signature",
	"Missing endorsement",
	"Amount mismatch - MDC doesn't match check",
	"Amount mismatch - Legal text doesn't match numeric amount",
	"Duplicated check",
	"Partial endorsement",
	"Name mismatch - Beneficiary",
	"Ineligible item - Screen Captured Image",
	"Ineligible item - Folded or Torn Corners",
	"Altered/Fictitious item",
]

function refreshAndClose(refresh: () => void, close: () => void) {
	return function () {
		refresh()
		close()
	}
}

export function RejectCheckModal({id, closeModal, onSuccess, isVeryfi}: RejectCheckModalProps) {
	const accessToken = useAccessToken()
	const [reason, setReason] = useState(isVeryfi ? presetReasonsVeryfi[0] : presetReasonsSmartpay[0])
	const [reasonText, setReasonText] = useState<string | undefined>(undefined)
	const [rejectedState, setRejectedState] = useAsyncResultIdle(rejectCheckDeposit)

	return (
		<AsyncResultModal
			title={`You Are About To Reject Check ID #${id}`}
			close={refreshAndClose(onSuccess, closeModal)}
			buttonClassname="is-danger"
			state={rejectedState}
			buttonText="Reject Check"
			successText="Check is rejected"
			onSubmit={() => {
				setRejectedState({id, accessToken, reason, reasonText: reasonText?.trim()})
			}}
			errorToText={(err) => err.errors[0].title}
		>
			<div className="field">
				<label className="label">Reason</label>
				<div className="control">
					<div className="select">
						<select onChange={(e) => setReason(e.target.value)} value={reason}>
							{isVeryfi
								? presetReasonsVeryfi.map((reason) => {
										return (
											<option key={reason} value={reason}>
												{reason}
											</option>
										)
								  })
								: presetReasonsSmartpay.map((reason) => {
										return (
											<option key={reason} value={reason}>
												{reason}
											</option>
										)
								  })}
						</select>
					</div>
					{!isVeryfi && (
						<div className="control">
							<br />
							<label className="label">Notes</label>
							<textarea
								className="textarea"
								placeholder="Why are you rejecting this check deposit?"
								value={reasonText}
								onChange={(e) => setReasonText(e.target.value)}
								disabled={reason !== "Other"}
								required={reason === "Other"}
							/>
						</div>
					)}
				</div>
			</div>
			<Admonition
				type={"is-danger"}
				message={
					<p>
						{
							"Rejecting a check is a final action that cannot be undone. The rejection reason and text specified will be visible to clients."
						}
					</p>
				}
				title={"Warning"}
			/>
		</AsyncResultModal>
	)
}
